// useSelection — guarded access to the selection context (US-878 · R-2/R-7/R-8).
//
// The single facade components use for drill-down: the active selection (drill
// path), the active level, and the navigation actions (setLevel / drillUp /
// clearSelection) plus the derived breadcrumb crumbs. State lives in UIContext
// and the map application in SelectionContext; this hook hides both behind one
// surface, guarded like `useLayers`/`useMap`.
import { useContext } from "react";
import { SelectionContext } from "../contexts/SelectionContext";

const useSelection = () => {
  const ctx = useContext(SelectionContext);
  if (ctx === null) {
    throw new Error("useSelection must be used within a <SelectionProvider>.");
  }
  return ctx;
};

export default useSelection;
